export default __webpack_public_path__ + "static/media/emotion-xl@2x.41bf1d26.png";